<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a widget that will autosave work on the page
    *
    * @since 20240206
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2024 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div :class="classes" style="top:10px;right:10px;z-index:1000;" @click="forceSave()">
        <i :class="[saving ? 'fas' : 'fa', saving ? 'fa-sync fa-spin' : (error ? 'fa-exclamation-triangle' : (changed ? 'fa-clock' : 'fa-check')), 'fa-lg']" aria-hidden="true"></i> 
        <span v-show="saving">Auto Saving</span><span v-show="!saving && !error">Save Status</span><span v-show="!saving && error">Save Error</span>
        <i v-show="changed && !saving" class="small"><br />Changed, Save the form</i>
        <i v-show="!changed && !saving && !error" class="small"><br />Up to Date</i>
        <i v-show="!changed && !saving && error" class="small"><br />Error</i>
        <i v-show="saving" class="small"><br />Updating...</i>
    </div>
</template>

<script>
    export default{
        props: {
            classes: {
                type: String,
                default: 'position-fixed btn btn-secondary'
            },
            name: {
                type: String,
                default: 'autosave'
            }
        },
        mounted() {
        },
        data() {
            return {
                changed: false,
                saving: false,
                countdown: 120,
                error: false,
                autoSaveAdded: false,
                progressJob: null
            }
        },
        computed: {
        },
        methods: {
            addAutoSave: function(object, variable, jobParams, reset=false){
                this.changed = false;
                this.saving = false;
                this.countdown = 120;
                this.error = false;
                if(!reset){
                    this.getSaveParams();
                }
                this.$autoSaveJobs.push({
                    name: this.name,
                    autoSaveObject: this,
                    object: object,
                    variable: variable,
                    jobParams: jobParams,
                    reset: reset
                });
                this.autoSaveAdded = true;
            },
            forceSave: function(){
                if(this.autoSaveAdded){
                    this.$autoSaveJobs.push({
                        name: this.name,
                        action: 'save'
                    });
                }
            },
            cancelSave: function(){
                if(this.autoSaveAdded){
                    this.$autoSaveJobs.push({
                        name: this.name,
                        action: 'cancel'
                    });
                }
            },
            getSaveParams: function(){
                if(this.progressJob !== null){
                    for(var i=0; i<this.progressJob.currAutoSaveJobs.length; i++){
                        if(this.progressJob.currAutoSaveJobs[i].name == this.name){
                            this.changed = this.progressJob.currAutoSaveJobs[i].changed;
                            this.saving = this.progressJob.currAutoSaveJobs[i].saving;
                            this.countdown = this.progressJob.currAutoSaveJobs[i].countdown;
                            this.progressJob.currAutoSaveJobs[i].autoSaveObject = this;
                        }
                    }
                }
            }
        },
        watch: {
            saving: function(){
                this.$emit('setSaving', this.saving);
            },
            name: function(){
                this.getSaveParams();
            }
        },
        destroyed() {
            this.forceSave();
        }
    }
</script>